import React, {Fragment} from 'react'
import {usePageContext} from 'Src/components/pages/SoftPull/PageContext'

const Errors = () => {
  const {errors} = usePageContext()

  return (
    <p id="errors" role="alert" aria-atomic="true" className="tw-sr-only">
      {Object.entries(errors).map(([errorKey, errorValue]) => (
        <Fragment key={errorKey}>
          <span>{errorValue.message}</span>
          <br />
        </Fragment>
      ))}
    </p>
  )
}

export default Errors
